import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { HashRouter } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { LayoutProvider } from "./context/LayoutContext";
import AppRoutes from "./routes/AppRoutes";
import { NotificationProvider } from "./context/NotificationContext";
import "./assets/scss/components/Loading.scss";
import { DownloadProvider } from "./context/DownloadContext";
import { OTPProvider } from "./context/OTPContext";
import { TourProvider } from "./context/TourContext";
import { SocketProvider } from "./context/SocketContext";
import { PersonsFilterProvider } from "./context/PersonsFilterContext";

// Configuración con opciones más agresivas de cache para mejorar rendimiento
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 3 * 60 * 1000,
      cacheTime: 5 * 60 * 1000,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      retry: 1,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <HashRouter>
        <NotificationProvider>
          <AuthProvider>
            <SocketProvider>
              <OTPProvider>
                <DownloadProvider>
                  <LayoutProvider>
                    <TourProvider>
                      <PersonsFilterProvider>
                        <AppRoutes />
                      </PersonsFilterProvider>
                    </TourProvider>
                  </LayoutProvider>
                </DownloadProvider>
              </OTPProvider>
            </SocketProvider>
          </AuthProvider>
        </NotificationProvider>
      </HashRouter>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
}

export default App;
